export default "__VITE_ASSET__DzJ44vLW__"